var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMoreVertical(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 2.5a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0zM6.5 8a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0zM6.5 13.5a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0z",
    fill: "#6D6D6D"
  })));
}

export default SvgIconMoreVertical;